import React, { useEffect, useRef, useState } from 'react';
import { LiaLongArrowAltLeftSolid } from 'react-icons/lia'
import { changeHeader } from '../../../redux/reducer/headerSlice';
import { useDispatch } from 'react-redux';
import { AiOutlineEye } from 'react-icons/ai'
import table from '../../../assests/icons/tableIcon.png'
import send from '../../../assests/icons/frame1.png'
import clip from '../../../assests/icons/clip.png'
import handleGet from '../../../utils/Get'
import handlePost from '../../../utils/Post'
import { BASE_URL } from '../../../utils/config';
import { useParams } from 'react-router';
import { Button, Modal, Spin } from 'antd';
import { Link } from 'react-router-dom';


export default function () {
    const { id } = useParams();
    const [message, setMessage] = useState('')
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [ticketData, setTicketData] = useState('')
    const [messageData, setMessageData] = useState({ ticket_id: id, message: '' })
    const user = JSON.parse(localStorage.getItem('user'));
    const messagesEndRef = useRef(null);

    const dispatch = useDispatch();

    useEffect(() => {
        handleFetchTiketDetails()
        dispatch(changeHeader(`${user.name}, Tickets`));
    }, [])

    useEffect(() => {
        handleFetchMessage();
    }, [])

    // Poll for new messages every 40 seconds
    useEffect(() => {
        const intervalId = setInterval(() => {
            handleFetchMessage();
        }, 40 * 1000)
        return () => {
            clearInterval(intervalId);
        }
    }, [])

    // Scroll to bottom whenever messages update
    useEffect(() => {
        if (Array.isArray(message)) {
            messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
        }
    }, [message])

    const handleFetchMessage = async () => {
        const data = await handleGet(`${BASE_URL}ticket/message/get/${id}`);
        setMessage(data?.message_data);
    }

    const handlePostMessage = async () => {
        if (!messageData?.message?.trim()) return;
        try {
            const response = await handlePost(`${BASE_URL}ticket/message/post`, messageData)
            if (response) {
                setMessageData({ message: '', ticket_id: id });
                handleFetchMessage();
            }
        }
        catch (error) {
            console.log(error)
        }
    }

    const handleFetchTiketDetails = async () => {
        const data = await handleGet(`${BASE_URL}ticket/view/${id}`);
        console.log(data)
        setTicketData(data?.ticket)
    }

    const handleOk = () => setIsModalOpen(false);
    const handleCancel = () => setIsModalOpen(false);

    if (!Array.isArray(message)) {
        return (
            <div className='w-full h-[80vh] flex justify-center items-center'>
                <Spin size='large' />
            </div>
        )
    }

    return (
        <main className='w-full h-full'>

            {/* Ticket Details Modal */}
            {ticketData && (
                <Modal
                    centered
                    title=""
                    open={isModalOpen}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    footer={(_, { OkBtn, CancelBtn }) => (
                        <>
                            <CancelBtn />
                            <Button onClick={handleOk}>Ok</Button>
                        </>
                    )}
                >
                    <p className='font-nunito text-2xl font-medium'>Ticket Details</p>
                    <p className='font-nunito text-lg font-medium mt-2'>Title: {ticketData?.title}</p>
                    <p className='font-nunito text-lg font-medium my-1'>Detail: {ticketData?.detail}</p>
                    <p className='font-nunito text-lg font-medium my-1'>Status: {ticketData?.status ?? 'Pending'}</p>
                </Modal>
            )}

            {/* Chat Container */}
            <section
                className='w-full bg-theme-white dark:bg-dark dark:border dark:border-[#334155] rounded-xl p-4 flex flex-col'
                style={{ height: '85vh' }}
            >
                {/* Header */}
                <div className='flex justify-between items-center mb-4 flex-shrink-0'>
                    <Link
                        to='/user/support'
                        className='w-10 h-9 bg-[#E6E8F0] dark:bg-dark-body dark:border dark:border-[#334155] flex justify-center cursor-pointer items-center rounded-lg'
                    >
                        <span className='dark:text-dark-text'>
                            <LiaLongArrowAltLeftSolid size={24} />
                        </span>
                    </Link>

                    <div
                        onClick={() => setIsModalOpen(true)}
                        className='w-fit h-fit cursor-pointer px-3 py-2 bg-[#E6E8F0] dark:bg-dark-body dark:border dark:border-[#334155] rounded-lg flex gap-2 items-center'
                    >
                        <span className='dark:text-dark-text flex gap-2 items-center'>
                            <AiOutlineEye />
                            <span className='font-nunito font-medium'>Ticket Details</span>
                        </span>
                    </div>
                </div>

                {/* Messages Area — scrollable */}
                <div className='flex-1 overflow-y-auto flex flex-col gap-3 pr-1'>
                    {message?.length ? (
                        message.map(({ message: msg, id: msgId, sender, time }) => {
                            // logged-in user's messages → RIGHT side (purple)
                            // other person's messages  → LEFT side (gray)
                            const isMe = sender?.id === user?.id;

                            return (
                                <div key={msgId} className={`w-full flex ${isMe ? 'justify-end' : 'justify-start'}`}>
                                    <div className='flex flex-col max-w-[70%]'>

                                        {/* Avatar + Bubble */}
                                        <div className={`flex items-end gap-2 ${isMe ? 'flex-row-reverse' : 'flex-row'}`}>
                                            <img className='w-8 h-8 rounded-full object-cover flex-shrink-0' src={table} alt={sender?.name} />
                                            <div
                                                className={`px-4 py-2 text-sm font-nunito leading-relaxed break-words ${isMe
                                                    ? 'bg-[#6c5dd3] text-white rounded-2xl rounded-br-sm'
                                                    : 'bg-[#E6E8F0] dark:bg-dark-body dark:border dark:border-[#334155] dark:text-dark-text text-gray-800 rounded-2xl rounded-bl-sm'
                                                    }`}
                                            >
                                                {msg}
                                            </div>
                                        </div>

                                        {/* Timestamp */}
                                        <div className={`text-[11px] text-gray-400 mt-1 font-nunito ${isMe ? 'text-right pr-10' : 'text-left pl-10'}`}>
                                            {new Date(time).toLocaleString('en-US', {
                                                dateStyle: 'medium',
                                                timeStyle: 'short',
                                            })}
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    ) : (
                        <div className='flex-1 flex items-center justify-center'>
                            <p className='font-nunito text-xl text-gray-400 dark:text-dark-text'>No chats yet</p>
                        </div>
                    )}

                    {/* Scroll anchor */}
                    <div ref={messagesEndRef} />
                </div>

                {/* Input Bar */}
                <div className='flex-shrink-0 flex items-center gap-3 border-t border-gray-200 dark:border-[#334155] pt-3 mt-3'>
                    <input
                        onKeyDown={e => e.key === 'Enter' && handlePostMessage()}
                        value={messageData?.message}
                        onChange={e => setMessageData({ ...messageData, message: e.target.value })}
                        className='flex-1 border-none outline-none text-sm px-2 bg-transparent dark:text-dark-text placeholder-gray-400 font-nunito'
                        type="text"
                        placeholder='Hello, How we can help you?'
                    />
                    <div className='flex items-center gap-3'>
                        <img className='w-6 h-6 cursor-pointer' src={clip} alt="" />
                        <div
                            onClick={handlePostMessage}
                            className='w-11 h-9 rounded-full cursor-pointer bg-[#6c5dd3] flex justify-center items-center hover:bg-[#5a4bbf] transition-colors'
                        >
                            <img src={send} alt="" />
                        </div>
                    </div>
                </div>
            </section>
        </main>
    )
}